import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../shared/notifiers/base-notifier';
import { Ref } from '../../shared/providers/ref';
import { MapProvider } from '../providers/map-provider';
import { MapRepositoryProvider } from '../../shared/providers/repository-providers';
import { FullExtentState } from '../states/full-extent-state';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils.js';

@Injectable({ providedIn: 'root' })
export class FullExtentNotifier extends BaseNotifier<FullExtentState> {
  private _externalGeometry: any | null = null;
  private watchHandle: { remove: () => void } | null = null;

  constructor(ref: Ref) {
    super(ref, { geometry: null, homeCenter: [0, 0], homeZoom: 0 });
  }

  override build(): void {
    const tryLoad = () => {
      const v = this.ref.read(MapProvider).state().view;
      if (!v) return false;
      this.ref.read(MapRepositoryProvider).instance.load().then(r => {
        if (r.success && r.data) {
          this.setState({ ...this.getStateValue(), homeCenter: r.data.center, homeZoom: r.data.zoom });
        }
      });
      const update = () => {
        if (!this._externalGeometry && v.extent) {
          this.setState({ ...this.getStateValue(), geometry: v.extent });
        }
      };
      update();
      this.watchHandle?.remove();
      this.watchHandle = reactiveUtils.watch(
        () => v.extent,
        () => update()
      );
      return true;
    };
    if (!tryLoad()) {
      const iv = setInterval(() => {
        if (tryLoad()) clearInterval(iv);
      }, 500);
    }
  }

  setGeometry(geometry: any | null): void {
    this._externalGeometry = geometry;
    if (geometry) {
      this.setState({ ...this.getStateValue(), geometry });
    } else {
      const v = this.ref.read(MapProvider).state().view;
      this.setState({ ...this.getStateValue(), geometry: v?.extent ?? null });
    }
  }

  goHome(): void {
    const view = this.ref.read(MapProvider).state().view;
    if (!view) return;
    if (this._externalGeometry) {
      (view as any).goTo(this._externalGeometry).catch(() => {});
    } else {
      const s = this.getStateValue();
      (view as any).goTo({ center: s.homeCenter, zoom: s.homeZoom }).catch(() => {});
    }
  }
}
